import { render, staticRenderFns } from "./salonList.vue?vue&type=template&id=4817b404&scoped=true"
import script from "./salonList.vue?vue&type=script&lang=js"
export * from "./salonList.vue?vue&type=script&lang=js"
import style0 from "./salonList.vue?vue&type=style&index=0&id=4817b404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817b404",
  null
  
)

export default component.exports